import { EntitiesStore } from './entities-store.abstract';

import { HttpClient } from '@angular/common/http';

import { Injector } from '@angular/core';

import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface IAthletePhotos {
  results: IPhotos[];
  count: number;
  pager:any;
  self: ISelf;
}

export interface IPhotos {
  competitions?: IPhotosCompetition[];
  smugmug_id: string;
  urls: IURL[];
  alt?:string;
}

export interface IPhotosCompetition {
  id: string;
  name: string;
  place: string;
  country: string;
  date_start: string;
  date_end: string;
}



export interface IURL {
  median: string;
}

export interface ISelf {
  title: string;
  href: string;
}




export class AthletePhotosStore extends EntitiesStore<IPhotos> {

  /**
   *The athlete id for make the request.
   *
   * @type {string}
   * @memberof AthletePhotosStore
   */
  athlete_id: string;
  constructor(http: HttpClient) {
    super('null', http);
  }

  /**
   *
   * {@inheritdoc}
   * @returns {Observable<any>}
   * @memberof AthletePhotosStore
   */
  getRequest(params: any, request_more: boolean = false): Observable<any> {
    this.loadingRef = true;
    let page = (((this.data.length === this.pagination.totalResults) && this.data.length !== 0) ? this.pagination.totalResults :
      request_more === true ? this.pagination.resultsPerPage + 10 : 10);
    page = page < 10 ? 10 : page;

    const paramsSet =
      request_more === false ? { 'athlete_id': this.athlete_id, 'sort_by': 'date', 'sort_order': 'DESC', '_format': "json" } : {
        'athlete_id': this.athlete_id,
        'sort_by': 'date',
        'sort_order': 'DESC',
        'page': (this.pagination.page + 1).toString(),
        '_format': 'json',
      } as any;
    return this.http.get(
      environment.drupal_api + (environment.photosAPI),
      {
        params: Object.assign(paramsSet, params)
      }
      )
      .pipe(
        tap((next: IAthletePhotos) => {
          if (request_more === false) {
            this.dataStream.next(next.results);
            this.data = next.results;
          } else {
            this.data = Array.from(this.data.concat(next.results).reduce((f, s) =>
              f.set((s as IPhotos).urls[0].median, s), new Map()
            ).values());

            this.dataStream.next(this.data);
          }
          this.pagination = {
            pages: next.pager.pages,
            page: next.pager.current_page,
            next_page:next.pager.next_page,
            totalResults: next.pager.count,
            resultsPerPage: next.pager.items_per_page} as any;
          this.loadingRef = false;
          this.requestMore = false;
        }));
  }



}
